import { createAuthClient } from 'better-auth/vue';
import { API_URL } from '@/config/api';

export const localBetterAuthEnabled = process.env.NODE_ENV === 'development'
  && process.env.VUE_APP_AUTH_PROVIDER === 'better-auth-local';
export const betterAuthEnabled = localBetterAuthEnabled || process.env.VUE_APP_AUTH_PROVIDER === 'better-auth';
let instance;
export function getBetterAuthClient() {
  if (!betterAuthEnabled) throw new Error('Better Auth is not enabled.');
  const url = new URL(API_URL);
  if (localBetterAuthEnabled && (url.protocol !== 'http:' || !['localhost', '127.0.0.1'].includes(url.hostname)
    || window.location.hostname !== url.hostname)) throw new Error('Use localhost for the API and frontend.');
  if (!localBetterAuthEnabled && url.protocol !== 'https:') throw new Error('Authentication requires HTTPS.');
  if (!instance) instance = createAuthClient({ baseURL: url.origin, fetchOptions: { credentials: 'include' } });
  return instance;
}
export function checkAuthResult(result) {
  if (result.error) throw new Error(result.error.message || 'Authentication failed');
  return result.data;
}
